import { Link } from 'react-router-dom'
import type { Movie } from '@/mocks/movies'

interface HotRankingProps {
  list: Movie[]
}

export default function HotRanking({ list }: HotRankingProps) {
  return (
    <div className="grid grid-cols-1 gap-x-8 gap-y-2 lg:grid-cols-2">
      {list.map((movie, index) => (
        <Link
          key={movie.id}
          to={`/detail/${movie.id}`}
          className="group flex items-center gap-3 rounded-lg border border-transparent px-2 py-3 transition-colors hover:border-background-300 hover:bg-background-50"
        >
          <span
            className={`w-7 shrink-0 text-center font-label text-xl leading-none ${
              index < 3 ? 'text-accent-600' : 'text-foreground-400'
            }`}
          >
            {String(index + 1).padStart(2, '0')}
          </span>

          <span className="h-16 w-[52px] shrink-0 overflow-hidden rounded-md bg-background-200">
            <img
              src={movie.poster}
              alt={`《${movie.title}》封面`}
              title={`${movie.title} - 热门推荐`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </span>

          <span className="min-w-0 flex-1">
            <span className="block truncate text-sm font-medium text-foreground-950 group-hover:text-accent-700">
              {movie.title}
            </span>
            <span className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-foreground-500">
              <span className="font-label tracking-wide">{movie.year}</span>
              <span className="text-background-400">/</span>
              <span className="truncate">{movie.genres.join(' · ')}</span>
            </span>
            <span className="mt-1 flex items-center gap-1 text-[11px] text-foreground-500">
              <i className="ri-user-star-line text-accent-600" />
              热度 {100 - index * 7}
            </span>
          </span>

          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors group-hover:border-accent-500 group-hover:bg-accent-500 group-hover:text-background-50">
            <i className="ri-play-fill text-sm" />
          </span>
        </Link>
      ))}
    </div>
  )
}